export default function AurocleLogo({ size = 32, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      {/* Outer hexagonal ring */}
      <path d="M32 4L56 18V46L32 60L8 46V18L32 4Z" stroke="#D4AF37" strokeWidth="1.5" fill="none" opacity="0.6" />
      {/* Inner diamond */}
      <path d="M32 14L48 32L32 50L16 32L32 14Z" stroke="#D4AF37" strokeWidth="1" fill="rgba(212,175,55,0.06)" />
      {/* Center node */}
      <circle cx="32" cy="32" r="4" fill="#D4AF37" />
      {/* Orbital dots */}
      <circle cx="32" cy="14" r="2" fill="#D4AF37" opacity="0.7" />
      <circle cx="48" cy="32" r="2" fill="#D4AF37" opacity="0.5" />
      <circle cx="32" cy="50" r="2" fill="#D4AF37" opacity="0.7" />
      <circle cx="16" cy="32" r="2" fill="#D4AF37" opacity="0.5" />
      {/* Connection lines from center */}
      <line x1="32" y1="28" x2="32" y2="16" stroke="#D4AF37" strokeWidth="0.5" opacity="0.4" />
      <line x1="36" y1="32" x2="46" y2="32" stroke="#D4AF37" strokeWidth="0.5" opacity="0.4" />
      <line x1="32" y1="36" x2="32" y2="48" stroke="#D4AF37" strokeWidth="0.5" opacity="0.4" />
      <line x1="28" y1="32" x2="18" y2="32" stroke="#D4AF37" strokeWidth="0.5" opacity="0.4" />
      {/* Corner accent dots */}
      <circle cx="56" cy="18" r="1.5" fill="#D4AF37" opacity="0.3" />
      <circle cx="56" cy="46" r="1.5" fill="#D4AF37" opacity="0.3" />
      <circle cx="8" cy="18" r="1.5" fill="#D4AF37" opacity="0.3" />
      <circle cx="8" cy="46" r="1.5" fill="#D4AF37" opacity="0.3" />
    </svg>
  );
}
